import { useEffect, useState } from 'react';

type TXTViewerProps = {
  fileUrl?: string;
};

export function TXTViewer({ fileUrl }: TXTViewerProps) {
  const [text, setText] = useState('');
  const [localFileUrl, setLocalFileUrl] = useState<string | null>(null);
  const activeFileUrl = fileUrl ?? localFileUrl;

  useEffect(() => {
    if (!activeFileUrl) return;

    const fetchTXT = async () => {
      const response = await fetch(activeFileUrl);
      const textData = await response.text();
      setText(textData);
    };

    fetchTXT();
  }, [activeFileUrl]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const blobUrl = URL.createObjectURL(file);
      setLocalFileUrl(blobUrl);
    }
  };

  if (!activeFileUrl) {
    return (
      <div>
        <input type="file" accept=".txt" onChange={handleFileChange} />
        <p>TXT</p>
      </div>
    );
  }

  if (!text) return <p>Loading TXT...</p>;

  return (
    <div className="h-full p-2 border border-gray-250v2 rounded-lg text-zinc-900 overflow-y-auto whitespace-pre-wrap">
      {text}
    </div>
  );
}
